import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TextAreaInput from '../../../../../../../../../../../../components/forms/text-area-input/TextAreaInput';
import TextInplaceEdit from '../../../../../../../../../../../../components/forms/text-inplace-edit/TextInplaceEdit';
import TextInput from '../../../../../../../../../../../../components/forms/text-input/TextInput';
import { IMachine } from '../../../../PcfWizard.type';
import RemoveButton from '../../RemoveButton';
import InputMaterialsSection from '../input-materials-section/InputMaterialsSection';
import EnergyInputSection from './components/energy-input-section/EnergyInputSection';

interface IndividualProcessFormProps {
  name: string;
  processIndex: number;
  onDelete: (showConfirmationDialog: boolean) => void;
}

const IndividualProcessForm = ({ name, processIndex, onDelete }: IndividualProcessFormProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const processes = useWatch({
    name: 'processes',
    control,
  });
  const machines = useWatch({
    name: `processes[${processIndex}].machines`,
    control,
  });

  return (
    <div className='mb-3'>
      <div className='flex flex-row w-full justify-content-between align-items-center'>
        <div className='w-full'>
          <TextInplaceEdit
            name={`${name}[${processIndex}].name`}
            placeholder={t(
              'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.processName',
            )}
            value={processes[processIndex].name}
            control={control}
            textSize='text-2xl'
          />
        </div>
        <RemoveButton
          onClick={() => {
            return onDelete(true);
          }}
        />
      </div>
      <div className='mt-4 mb-4 font-light text-black-alpha-60'>
        {t(
          'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.description',
        )}
      </div>
      <InputMaterialsSection name={name} processIndex={processIndex} />

      <div className='mt-4'>
        {/* Machine Section */}
        {machines?.map((_machine: IMachine, index: number) => {
          return (
            <div key={index} className='surface-ground border-round-2xl p-3'>
              <EnergyInputSection name={name} processIndex={processIndex} machineIndex={index} />

              <div className='grid'>
                <div className='col-12 mt-4'>
                  <TextAreaInput
                    name={`processes[${processIndex}].machines[${index}].comment`}
                    label={t(
                      'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.comment',
                    )}
                    control={control}
                    rows={3}
                    className='w-full h-full'
                  />
                </div>

                {/* TODO: Remove this when implementing calculation with individual process */}
                <div>
                  <TextInput
                    name={`processes[${processIndex}].machines[${index}].quality_assessment`}
                    control={control}
                    value={'TODO'}
                    defaultValue={'TODO'}
                    type='hidden'
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IndividualProcessForm;
